import Vue from 'vue'
import Router from 'vue-router'
import { asyncRouterMap } from '@/config/router.config'
import router from '../store/index.js'
//update-begin-author:taoyan date:20191011 for:TASK #3214 【优化】访问online功能测试 浏览器控制台抛出异常
try {
  const originalPush = Router.prototype.push
  Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
  }
} catch (e) {
}
//update-end-author:taoyan date:20191011 for:TASK #3214 【优化】访问online功能测试 浏览器控制台抛出异常

Vue.use(Router)

let scrollBehavior = (to,from)=>{
  console.log('to',to);
  console.log('meta',to.meta.navIndex);
  router.state.navIndex = to.meta.navIndex
  console.log('router',router.state.navIndex);
  console.log('router',router.state);
}

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  scrollBehavior: scrollBehavior,
  routes: asyncRouterMap
})